<template>
  <LoadingRights>
    <div class="h-screen w-full">
      <div class="fixed top-0 z-30 w-full">
        <AppHeader />
      </div>
      <div class="flex h-full pt-14">
        <!-- Sidebar desktop (repliable en rail d'icônes) -->
        <aside
          class="sidebar-desktop flex shrink-0 flex-col border-r border-gray-200 transition-[width] duration-200 ease-in-out"
          :class="collapsed ? 'w-16' : 'w-64'"
        >
          <div class="min-h-0 flex-1 overflow-hidden">
            <ParametersSidebar :variant="collapsed ? 'rail' : 'full'" />
          </div>
          <div
            class="collapse-footer flex border-t border-gray-200 p-2"
            :class="collapsed ? 'justify-center' : 'justify-end'"
          >
            <sgdf-icon-button
              :name="collapsed ? 'angles-right' : 'angles-left'"
              :label="
                collapsed
                  ? $t('label.parameters.expand')
                  : $t('label.parameters.collapse')
              "
              @click="collapsed = !collapsed"
            />
          </div>
        </aside>

        <!-- Sidebar mobile : rail d'icônes permanent -->
        <aside class="sidebar-mobile shrink-0 border-r border-gray-200">
          <ParametersSidebar variant="rail" />
        </aside>

        <!-- Contenu -->
        <div class="min-w-0 flex-1 overflow-y-auto bg-white">
          <slot></slot>
        </div>
      </div>
    </div>
  </LoadingRights>
</template>

<script setup lang="ts">
import "@sgdf/ui-library/sgdf-icon-button.js";

const { collapsed } = useSidebarStore();
</script>

<style scoped>
.sidebar-desktop {
  background: var(--sgdf-color-bg-neutral, #fff);
}

.collapse-footer sgdf-icon-button {
  --icon-color: var(--sgdf-color-gray-500, #6b7280);
}

/* Desktop : sidebar repliable visible, rail mobile masqué */
@media (min-width: 1024px) {
  .sidebar-mobile {
    display: none;
  }
}

/* Mobile : sidebar desktop masquée, rail au relais */
@media (max-width: 1023px) {
  .sidebar-desktop {
    display: none;
  }
}
</style>
